/**
 * 2019-11-05
 * handan
 * 获取屏幕信息
 */

import Base from "../base/base";
class Screen extends Base{
  constructor(){
    super()
  }
  getScreenPixel(){
    if(!window.screen) return {} ;
    let width = window.screen.width ;   // 获取屏幕宽度
    let height = window.screen.height ;   // 获取屏幕高度
    let avaiWidth = window.screen.avaiWidth ;   // 获取屏幕宽度，除去系统的任务栏所占宽度
    let avaiHeight = window.screen.avaiHeight ;   // 获取屏幕高度，除去系统的任务栏所占高度
    return {
      width,
      height,
      avaiWidth,
      avaiHeight,
    }
  }
}

export default new Screen() ;